"use strict";

/**
* Базовый класс строк и столбцов таблицы. 
* Содержит общие методы.
* 
* @class WebAccess.components.wrappers.form.BaseTableLine
* @abstract
* @extends BaseObject
* @param {string} itemSelector существующий элемент страницы
* @param {WebAccess.components.wrappers.form.Table} parentTable Таблица, которой принадлежит строка или столбец
*/
(function (global) {

  var BaseTableLine = BaseObject.extend([global.mixins.requisitesMixin], {
    className: "BaseTableLine",

    _parentTable: null,
    _isDisabled: false,
    _jDataItems: null,

    init: function (itemSelector, parentTable) {
      var me = this;
      me._super(itemSelector);
      me._jObject = $(itemSelector);
      me._parentTable = parentTable;
      me._isDisabled = parentTable.isDisabled();
    },

    /**
    * Признак недоступности строки для изменения.
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#isDisabled
    * @return {boolean} True – строка доступна только для чтения , иначе False.
    */
    isDisabled: function () {
      return this._isDisabled;
    },

    /**
    * Cделать элемент недоступным.
    * Делает недоступными вложенные в элемент реквизиты. 
    * Реквизитам присваивается атрибут «Только чтение».
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#disable
    * @return {WebAccess.components.wrappers.form.BaseTableLine} Объект типа BaseTableLine.
    */
    disable: function () {
      this._disable();
      this._isDisabled = true;
      this.fire('disable');
      return this;
    },

    /**
    * Cделать элемент доступным.
    * Делает доступными вложенные в элемент реквизиты. С реквизитов убирается атрибут «Только чтение».
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#enable
    * @return {WebAccess.components.wrappers.form.BaseTableLine} Объект типа BaseTableLine.
    */
    enable: function () {
      this._enable();
      this._isDisabled = false;
      this.fire('enable');
      return this;
    },

    /**
    * Cкрыть элемент.
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#hide
    * @return {WebAccess.components.wrappers.form.BaseTableLine} Объект типа BaseTableLine.
    */
    //FIXME: Shabardin_PI: WA.CR.form.controls.tables.STcxGrid1.columns["НомСтр"].hide() - большая печаль с заголовками и с таблицей в целом при скрытии столбца.
    hide: function () {
      var me = this;
      _(me.requisites.toArray()).each(function (req) {
        req.hide();
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отобразить элемент.
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#show
    * @return {WebAccess.components.wrappers.form.BaseTableLine} Объект типа BaseTableLine.
    */
    show: function () {
      
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Формирует полное имя реквизита - с номер детального раздела и номером строки черех символ $.
    * @method WebAccess.components.wrappers.form.BaseTableLine#_makeFullName
    * @private
    * @since 5.0.0.7100
    */
    _makeFullName: function (reqName, newRowNum) {
      return '' + this._parentTable.detailNum + '$' + newRowNum + '$' + reqName;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Возвращает таблицу, к которой относится строка.
    *
    * @method WebAccess.components.wrappers.form.BaseTableLine#getTable
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table
    */
    getTable: function () {
      return this._parentTable;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.components.wrappers.form.BaseTableLine = BaseTableLine;
})(window.WebAccess);